export default __webpack_public_path__ + "static/media/hex_green.bbd77e18.svg";